module.exports = __webpack_public_path__ + "media/tags/mid-game-6e6359dc.png";